<!-- 默认的交易账户申请表单 -->
<template>
  <div class="default-apply-form">
    <!-- <div class="card-base card-shadow--small  p-30" v-if="['FUTURES_DAYTRADING_MARGIN'].includes(tradeAccountType) && ['OPEN','SUCCESS'].includes(status)">
      <h2 class="account-info-title">{{$t('applyTradeAccount.fmdInfo')}}</h2>
      <p class="top-title">{{$t('applyTradeAccount.logOutQues.title')}}</p>
      <div v-for="(item,index) in checkStopDatasAgree" :key="index" class="check-item">
                <el-checkbox v-model="item.checked" test_id="check_box_want_to_buy"></el-checkbox>
                <span class="checked-value">{{item.data}}</span>
      </div>
      <div class="apply-btn">
        <el-button @click="submitStopHandle" test_id= "createAccount">
            {{$t('applyTradeAccount.confirm')}}
        </el-button>
      </div>

    </div> -->
    <div class="card-base card-shadow--small  p-30">
      <confirmInfoForm
        :status="status"
        :tradeAccountType="tradeAccountType"
        :remark="remark"
        @changeComfirmInfo="changeComfirmInfo"
        />
        <div class="apply-notice" v-if="isShowAgree">
          <!-- <el-row>
            <div v-if="['FUTURES_DAYTRADING_MARGIN','FUTURES_MARGIN'].includes(tradeAccountType)">
              <p class="tip-title">{{$t('tradeProduct.titleTip')}}</p>
              <div v-for="(item,index) in checkDatasAgree" :key="index" class="check-item">
                <el-checkbox v-model="item.checked" test_id="check_box_want_to_buy"></el-checkbox>
                <span class="checked-value">{{item.data}}</span>
              </div>
            </div>
          </el-row> -->
          <!-- 投资目的 -->
        <el-row v-if="!isOpenStructuredProduct">
          <div v-if="['FUTURES_DAYTRADING_MARGIN','FUTURES_MARGIN'].includes(tradeAccountType)">
            <p class="tip-title">{{$t('common.invest')}}</p>
            <div v-for="(item,index) in investTarget" :key="index" class="invest-item">
              <el-checkbox v-model="item.checked" :disabled="!!item.status"></el-checkbox>
              <span class="checked-value">{{item.data}}</span>
            </div>
          </div>
        </el-row>
        <!-- 风险承受能力 -->
          <el-row v-if="!isOpenStructuredProduct">
            <div v-if="['FUTURES_DAYTRADING_MARGIN','FUTURES_MARGIN'].includes(tradeAccountType)">
              <p class="tip-title">{{$t('common.riskTolerance')}}</p>
              <el-select
                  v-model="riskTolerance"
                  :placeholder="$t('common.please_select')"
                  class="currency-select"
                >
                <el-option
                  v-for="(item,index) in riskToleranceList"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-row>

          <el-row>
            <h3>{{$t('applyTradeAccount.infomationTips.read')}}</h3>
          </el-row>
            <div v-if="tradeAccountType === 'FUTURES_DAYTRADING_MARGIN'" >
              <fdmtApplyForm
              @submitForm="submitForm"
              :status="status"
              />
            </div>
            <div v-else>
              <defaultArticleContent
              @submitForm="submitForm"
              :status="status"
              />
            </div>
          </div>
          <div class="eddidTips" v-if="isShowTips">
            <p class="font-sx-pf">{{$t('applyTradeAccount.tipsText1')}}</p>
            <p>{{$t('applyTradeAccount.tipsText2')}}</p>
          </div>
    </div>
  </div>
</template>
<script>
import defaultArticleContent from './defaultArticleContent'
import fdmtApplyForm from './fdmtApplyForm'
import confirmInfoForm from './confirmInfoForm'
import tradeApi from '@/api/v2/trade'
export default {
  components: {
    defaultArticleContent,
    fdmtApplyForm,
    confirmInfoForm
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    tradeAccountType: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    },
    tradeAccountNumber: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowButton: true,
      isShowAgree: false,
      isShowTips: false,
      infoIsSome: false,
      checkDatasAgree: [
        {
          data: this.$t('tradeProduct.infomationTips1'),
          checked: false,
          link: '',
          linkContext: '',
          type: 'isDerivativesKnowledge'
        },
        {
          data: this.$t('tradeProduct.infomationTips2'),
          checked: false,
          link: '',
          linkContext: '',
          type: 'isDerivativesDeal'
        },
        {
          data: this.$t('tradeProduct.infomationTips3'),
          checked: false,
          link: '',
          linkContext: '',
          type: 'isDerivativesWork'
        }
      ],
      futuresCognize: {},
      checkStopDatasAgree: [
        {
            data: this.$t('applyTradeAccount.logOutQues.Q1'),
            checked: false,
            link: '',
            linkContext: ''
          },
          {
            data: this.$t('applyTradeAccount.logOutQues.Q2'),
            checked: false,
            link: '',
            linkContext: ''
          }
      ],
      // 风险承受能力
      riskToleranceList: [
        {
          value: 'HIGH',
          text: this.$t('common.high')
        }
      ],
      riskTolerance: 'HIGH',
      userInvestmentInfo: {},
      // 投资目的
      investTarget: [
        {
          data: this.$t('common.speculation'),
          checked: false,
          type: 'SPECULATION'
        },
        {
          data: this.$t('common.hedge'),
          checked: false,
          type: 'HEDGING'
        },
        {
          data: this.$t('common.assetAppreciation'),
          checked: false,
          type: 'ASSET'
        },
        {
          data: this.$t('common.interestIncome'),
          checked: false,
          type: 'INCOME'
        }
      ],
      isOpenStructuredProduct: false
    }
  },
  mounted() {
    this.getInvestmentInfo()
    if (['FUTURES_DAYTRADING_MARGIN', 'FUTURES_MARGIN'].includes(this.tradeAccountType)) {
      this.getStructuredStatus()
    }
  },
  methods: {
    async getInvestmentInfo() {
      let res = await tradeApi.getInvestmentInfo()
      this.userInvestmentInfo = res.data || {}
      let arr = ['purposesSpeculation', 'purposesHedging', 'purposesAsset', 'purposesIncome']
      arr.map((item, key) => {
        this.$set(this.investTarget[key], 'checked', !!this.userInvestmentInfo[item])
        this.$set(this.investTarget[key], 'status', this.userInvestmentInfo[item] ? 'disable' : '')
      })
      if (this.userInvestmentInfo.riskTolerance === 'LOW') {
        this.riskToleranceList.push(
          {
            value: 'MIDDLE',
            text: this.$t('common.medium')
          },
          {
            value: 'LOW',
            text: this.$t('common.low')
          }
        )
      } else if (this.userInvestmentInfo.riskTolerance === 'MIDDLE') {
        this.riskToleranceList.push({
          value: 'MIDDLE',
          text: this.$t('common.medium')
        })
      }
    },
    getStructuredStatus() {
      tradeApi.getStructuredStatus().then(res => {
        let data = res.data ? res.data : {}
        this.isOpenStructuredProduct = data.isOpenStructuredProduct === 'opened'
      })
    },
    submitForm (val) {
      // 至少勾选一项衍生品相关经验 期货
    // if (['FUTURES_DAYTRADING_MARGIN', 'FUTURES_MARGIN'].includes(this.tradeAccountType)) {
    //   let experienceTag = this.checkDatasAgree.some(item => {
    //     return item.checked
    //   })
    //   if (!experienceTag) {
    //     this.$message.error(this.$t('applyTradeAccount.oneInfo'))
    //     return
    //   }
    // }
    // this.checkDatasAgree.map(item => {
    //   if (item.checked) {
    //     this.futuresCognize[item.type] = 'Y'
    //   } else {
    //     this.futuresCognize[item.type] = 'N'
    //   }
    // })
    // 投资目的不能不选 也不能仅仅为利息/股息收入
      let targetArr = []
      if (['FUTURES_DAYTRADING_MARGIN', 'FUTURES_MARGIN'].includes(this.tradeAccountType)) {
        let filterArr = this.investTarget.filter((item) => {
          return item.checked
        })
        if (filterArr && filterArr.length === 0) {
          this.$message.error(this.$t('common.targetError'))
          return
        }
        if (
          filterArr &&
          filterArr.length === 1 &&
          filterArr[0].type === 'INCOME'
        ) {
          this.$message.info(this.$t('common.futuredErrorInfo'))
          return
        }
        this.investTarget.map((item) => {
          if (item.checked) {
            targetArr.push(item.type)
          } else {
            targetArr.push('')
          }
        })
      }
      let params = {
        agree: val.agree,
        infoIsSome: this.infoIsSome,
        futuresCognize: this.futuresCognize
      }
      if (['FUTURES_DAYTRADING_MARGIN', 'FUTURES_MARGIN'].includes(this.tradeAccountType)) {
        params = {
          agree: val.agree,
          infoIsSome: this.infoIsSome,
          futuresCognize: this.futuresCognize,
          investmentInfo: {
            // ...this.form,
            // investmentExperienceOther: this.otherInvestment || null,
            riskTolerance: this.riskTolerance || null,
            purposesSpeculation: targetArr[0] || null,
            purposesHedging: targetArr[1] || null,
            purposesAsset: targetArr[2] || null,
            purposesIncome: targetArr[3] || null
          }
        }
      }
      this.$emit('createAccount', params)
    },
    changeComfirmInfo (val) {
      this.infoIsSome = val.infoIsSome
      if (this.infoIsSome === 'yes') {
        this.isShowButton = true
        this.isShowAgree = true
        this.isShowTips = false
      } else {
        this.isShowButton = false
        this.isShowAgree = false
        this.isShowTips = true
      }
    }
    // 停用期货日内
    // async submitStopHandle () {
    //   let isAllAgree
    //   isAllAgree = this.checkStopDatasAgree.some(item => {
    //     return !item.checked
    //   })
    //   if (isAllAgree) {
    //     return this.$message.error(this.$t('applyTradeAccount.agree'))
    //   }
    //   let params = {
    //     action: 'STOP',
    //     agree: true,
    //     submitSource: 'CP_WEB',
    //     tradeAccountNumber: this.tradeAccountNumber
    //   }
    //   let res = await api.submitStopAccount(params)
    //   console.log(res)
    // }
  }
}
</script>

<style lang="scss" scoped>
.default-apply-form {
  .p-30 {
    padding: 0px 30px 30px 30px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .eddidTips {
    font-size: 14px;
    padding: 5px;
  }
  .apply-notice {
    h3 {
      color: rgba(36, 40, 45, 1);
      font-size: 16px;
      font-family: Muli-Bold;
    }
  }
    .tip-title{
      color: rgba(36, 40, 45, 1);
      font-weight: 600;
    }
    .check-item{
      line-height: 30px;
    }
    .invest-item{
      margin-bottom: 10px;
    }
    .checked-value{
      color: rgba(36, 40, 45, 1);
      margin-left: 10px;
    }
    .apply-btn {
    margin-top: 20px;
    .el-button {
      width: 250px;
      height: 56px;
      border-radius: 5px;
      background-color: #fec000;
      color: #182a54;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      font-family: PingFangSC-Semibold;
    }
  }

}
</style>
